<template>
  <div class="grid-question-wrapper">
    <div v-if="question" class="grid-question">
      <h2 v-if="notFirst">{{ question.intro }}</h2>
      <h2 v-if="!notFirst">
        Was möchten Sie <br class="mobile-selection" />
        reparieren lassen?
      </h2>
      <div
        :class="{
          'grid-question-options':
            question.config.options[0].title !== 'Uhr' &&
            question.config.options[0].title !== 'Schmuck',
        }"
      >
        <grid-option-list :option-list="this.question.config.options" />
      </div>
    </div>
  </div>
</template>

<script>
import GridOptionList from "../diagnosis/GridOptionList";

export default {
  name: "GridQuestion",
  components: {
    GridOptionList,
  },
  data() {
    return {
      notFirst: true,
    };
  },
  computed: {
    question: function () {
      return this.$store.state.questions[0] || false;
    },
  },
  mounted() {
    if (
      this.$store.state.questions[0].intro ==
      "Was möchten Sie reparieren lassen?"
    ) {
      this.notFirst = false;
    } else {
      this.notFirst = true;
    }
  },
};
</script>
